import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-text',
  templateUrl: './d-text.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DTextComponent),
      multi: true
    }
  ]
})
export class DTextComponent extends DynamicComponentBase implements AfterViewInit {
  static KEY = 'd-text';

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.config.labelWidth = 0;
    }, 0);
  }
  configChange(config: IDynamicComponentConfig) {
    if (config && !config.value) {
      this.config.value = '示例文字';
    }
  }
}
